import React from 'react';

import { formatBRL, NormalizedOffer } from '../hireValues';
import { Badge } from '../styles';
import * as S from './styles';

type Props = {
  offer: NormalizedOffer;
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  name?: string;
  info?: React.ReactNode;
};

export const OfferCardList = S.List;

const OfferCard = ({ offer, selected, onSelect, disabled, name = 'hire-offer', info }: Props) => (
  <S.Card isSelected={selected} isDisabled={disabled}>
    <input
      type="radio"
      name={name}
      checked={selected}
      disabled={disabled}
      onChange={() => !disabled && onSelect()}
    />
    <S.Content>
      <S.Header>
        <S.Title>
          {offer.name}
          {disabled && <S.Unavailable>(Indisponível)</S.Unavailable>}
        </S.Title>
        {offer.installmentValue > 0 && (
          <Badge variant="primary">{formatBRL(offer.installmentValue)}/mês</Badge>
        )}
        {info}
      </S.Header>
      {offer.installments > 0 && offer.installmentValue > 0 && (
        <S.Details>
          {offer.installments}x de <b>{formatBRL(offer.installmentValue)}</b>
          {offer.totalPremium > 0 && (
            <>
              {' · '}Prêmio total <b>{formatBRL(offer.totalPremium)}</b>
            </>
          )}
        </S.Details>
      )}
    </S.Content>
  </S.Card>
);

export default OfferCard;
